/** @format */

import FolderOpenOutlined from '@mui/icons-material/FolderOpenOutlined';
import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { useAppSelector } from '../../../../app/hooks';
import CircularLoader from '../../../../common/loaders/circularLoader';
import { selectApplicant } from '../../ApplicantSlice';
import { ApplicationDetailsDto } from '../../Models';
import ExtensionChecker from './documents/ExtensionChecker';

interface Props {
  applicant: ApplicationDetailsDto | null;
}
export default function DocumentsInfo({ applicant }: Props) {
  const applicantSelect = useAppSelector(selectApplicant);

  return (
    <Box sx={{ pt: 0.5 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        sx={{ mb: 2.5 }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: (t) =>
              t.palette.mode === 'light'
                ? 'rgba(25, 118, 210, 0.08)'
                : 'action.selected',
            color: 'primary.main',
          }}>
          <FolderOpenOutlined />
        </Box>
        <Box>
          <Typography variant='h6' sx={{ fontWeight: 800 }}>
            My documents
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            Open a file to view or download. Pending items show until you upload them on the application.
          </Typography>
        </Box>
      </Stack>
      <CircularLoader status={applicantSelect.loginState.status} />
      {applicant && (
        <Grid container spacing={2}>
          {applicant.documents.map((document, key: React.Key) => (
            <Grid item xs={6} sm={4} md={3} key={key}>
              <ExtensionChecker document={document} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
